import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "buyingHistory" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { ElNotification } from 'element-plus'
import { initEmptyParam } from '@/hooks/useInitParam'
import useClipboard from 'vue-clipboard3'


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyingHistory',
  setup(__props) {

initEmptyParam()
const { toClipboard } = useClipboard()

const generate = async (url: string) => {
  try {
    await toClipboard(url)
    ElNotification({
      title: '复制成功',
      message: '快去黏贴给客户吧',
      type: 'success'
    })
  } catch (e) {
    ElNotification({
      title: '复制失败',
      message: '请等一会，复制',
      type: 'error'
    })
  }
}
const [pageContentRef, handleResetClick, handleSearchClick, handleDownBtnClick] = usePageSearch()

function getDictName(prop:any,val:any){
    const userItem = searchFormConfig.formItems.find(
      (item) => item.field === prop
    )
    if(userItem?.options){
      return userItem.options.find((item:any) => item.value == val)?.title
    }else{
      return val || ''
    }
}


return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "liveQuanzi",
      downFilename: "直播间购买记录.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick)
    }, {
      signUrl: _withCtx((scope) => [
        _createVNode(_component_el_button, {
          size: "mini",
          type: "primary",
          onClick: ($event: any) => (generate(scope.row.signUrl))
        }, {
          default: _withCtx(() => [
            _createTextVNode("点击复制")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      price: _withCtx((scope) => [
        _createTextVNode(" ￥" + _toDisplayString(parseFloat(scope.row.price / 100).toFixed(2)), 1)
      ]),
      refundAmount: _withCtx((scope) => [
        _createTextVNode(" ￥" + _toDisplayString(parseFloat(scope.row.refundAmount / 100).toFixed(2)), 1)
      ]),
      status: _withCtx((scope) => [
        _createTextVNode(_toDisplayString(getDictName('status',scope.row.status)), 1)
      ]),
      channelCode: _withCtx((scope) => [
        _createTextVNode(_toDisplayString(getDictName('channelCode',scope.row.channelCode)), 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onDownBtnClick"])
  ]))
}
}

})